var exports = {
  "qr": "footer__evnOBN",
  "jH": "spacer__oqbDuD",
  "pI": "footerItem__UC05DZ",
};

module.exports = exports;
